import {Component, Input} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

type Location = 'home' | 'rooms' | 'groupmates' ;

@Component({
    selector: 'app-menu-bar',
    templateUrl: './menu-bar.component.html',
    styleUrls: ['./menu-bar.component.scss'],
    standalone: true,
    imports: [MatButtonModule, RouterLink, MatTooltipModule, FaIconComponent]
})
export class MenuBarComponent {

  @Input()
  location: Location = 'home';


  getBorderClass(location: Location) {
    if (location == this.location) {
      return 'border-slate-200'
    } else {
      return 'border-slate-700'
    }
  }

  getColor(location: Location) {
    if (location == this.location) {
      return 'primary'
    } else {
      return 'accent'
    }
  }
}
